import { apiClient } from "@/services/api.client"

export type FeedbackApp = "nira" | "oio_sim" | "oia_sim"
export type FeedbackTarget = "answer" | "draft"

export interface FeedbackRow {
  app: FeedbackApp
  session_id: string
  request_id: string | null
  turn_key: string | null
  target: FeedbackTarget
  vote: 1 | -1 | null
  reasons: string[]
  comment: string | null
}

export interface FeedbackBody {
  app: FeedbackApp
  session_id: string
  request_id?: string
  turn_key?: string
  target: FeedbackTarget
  vote: 1 | -1 | null
  reasons: string[]
  comment?: string
}

export const ANSWER_REASONS = [
  "Inaccurate", "Outdated law or rate", "Wrong or missing citation", "Not relevant", "Incomplete", "Hard to follow", "Other",
] as const
export const DRAFT_REASONS = ["Wrong facts", "Wrong law or section", "Missing section", "Weak reasoning", "Formatting", "Other"] as const

export const putFeedback = (body: FeedbackBody) => apiClient.put<FeedbackRow>("/api/v1/feedback", body)
export const getFeedback = (app: FeedbackApp, sessionId: string) =>
  apiClient.get<{ items: FeedbackRow[] }>("/api/v1/feedback", { app, session_id: sessionId })
